import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IApplicationState } from 'Store/types'
import {
  removeVehicleAccessory,
  saveVisit,
  setVehicleAccessoryFileContent,
} from '../../Actions/reducer'
import { useTranslation } from 'react-i18next'
import {
  getUploadLink,
  uploadVehicleAccessoriesFiles,
  uploadVehicleAccessoriesFilesPodSpace,
} from '../../Actions/action'
import VehicleAccessoryNew from './VehicleAccessoryNew'
import Icon from 'Components/Icon'
import PodSpaceImage from 'Components/Image/PodSpaceImage'
import { useNetStatus } from 'Contexts/NetStatusContext'
import Consts from 'Utils/Consts'
import { useSettings } from 'Contexts/SettingsContext'
import BottomSheet from 'Components/BottomSheet'

const VehicleAccessoriesPage = (props: { handleNext: () => void; handleBack: () => void }) => {
  const [t] = useTranslation()
  const { data, loading } = useSelector(
    (store: IApplicationState) => store.visits.newVisit.vehicleAccessories,
  )
  const { uploadLink } = useSelector((store: IApplicationState) => store.visits.newVisit)
  const { storeFileType } = useSelector((store: IApplicationState) => store.visits.newVisit)
  const { link } = useSelector((store: IApplicationState) => store.visits.newVisit.uploadLink)
  const { netStatus } = useNetStatus()
  const { settings } = useSettings()
  const dispatch = useDispatch()
  const [mode, setMode] = useState<'LIST' | 'NEW'>('LIST')
  const [nextModalVisible, setNextModalVisible] = useState(false)

  const uploadLinkSize =
    (settings?.REACT_APP_UPLOAD_LINK_SIZE ?? Consts.env.REACT_APP_UPLOAD_LINK_SIZE) || 10200

  const onNextHandleClick = () => {
    if (netStatus != 'MANUAL_OFF') {
      if (storeFileType == 'POD_SPACE') {
        // if (link) {
        //   dispatch(uploadVehicleAccessoriesFilesPodSpace({ handleNext: props.handleNext, uploadLink: link }))
        // } else {
        dispatch(
          getUploadLink({
            data: { sizeInKB: uploadLinkSize, visitId: 0, type: 4 },
            handleNext: props.handleNext,
          }),
        )
        // }
      } else {
        dispatch(uploadVehicleAccessoriesFiles(props.handleNext))
      }
    } else {
      dispatch(saveVisit())
      props.handleNext()
    }
  }

  return (
    <React.Fragment>
      <div className="flex flex-col grow overflow-auto">
        <div className="px-6 pb-6">
          <div className="text-sm mb-8">{t('REGISTER-THE-ADDITIONAL-CAR-ACCESSORIES')}</div>

          {mode == 'LIST' ? (
            <div className="grid grid-cols-2 gap-4 mt-3">
              <div className="flex gap-4" onClick={() => setMode('NEW')}>
                <div className="h-36 bg-primary/[.08] hover:bg-primary/[.16] min-w-[163px] text-primary text-xs border border-primary border-dashed rounded-lg flex flex-col gap-2 justify-center items-center bg-cover bg-no-repeat bg-center">
                  <Icon name="camera" className="w-6 h-6" />
                  {t('NEW_VEHICLE_ACCESSORY')}
                </div>
              </div>
              {data.map((x, i) => {
                return (
                  <div
                    style={{ position: 'relative' }}
                    className={loading && Number(x?.status) != 1 ? 'loading' : ''}
                  >
                    <PodSpaceImage
                      isPodSpace={storeFileType == 'POD_SPACE'}
                      className="flex flex-col justify-between w-40 h-36 rounded-lg border border-dashed border-gray-500 bg-cover bg-no-repeat bg-center overflow-hidden"
                      hashFile={x?.hashFile}
                      fileId={x?.fileId}
                      fileContent={x?.image}
                      onLoad={(image: string) =>
                        dispatch(setVehicleAccessoryFileContent({ id: x?.id, image }))
                      }
                    >
                      {x && (
                        <div
                          className="border-gray-950 text-gray-950 self-end m-1 w-5 h-5 flex justify-center items-center"
                          onClick={() => dispatch(removeVehicleAccessory(x.id))}
                        >
                          <Icon name="close-square" className="w-6 h-6" />
                        </div>
                      )}
                      <div className="bg-white p-2 text-center text-gray-900 text-xs w-full">
                        {x.name}
                        <div className="bg-gray-500/15 text-gray-800 font-bold text-xs rounded-md p-2 mt-1">
                          {Number(x.price).toLocaleString()}
                        </div>
                      </div>
                    </PodSpaceImage>
                    {Number(x?.status) == 1 ? (
                      <span style={{ position: 'absolute', top: 5, right: 5, fontSize: 10 }}>
                        {t('UPLOADED')}
                      </span>
                    ) : (
                      ''
                    )}

                    {loading &&
                      Number(x?.status) != 1 &&
                      Number(x?.uploadProgress) > 0 &&
                      Number(x?.uploadProgress) < 100 && (
                        <span
                          style={{ position: 'absolute', top: 5, right: 5, fontSize: 10 }}
                        >{`%${Math.round(Number(x?.uploadProgress))}`}</span>
                      )}
                  </div>
                )
              })}
            </div>
          ) : (
            <VehicleAccessoryNew onCapture={() => setMode('LIST')} />
          )}
        </div>
      </div>

      <BottomSheet title="" visible={nextModalVisible} onCancel={() => setNextModalVisible(false)}>
        <div
          style={{
            width: 50,
            height: 6,
            backgroundColor: '#ccc',
            borderRadius: 3,
            position: 'absolute',
            top: 8,
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        />

        <div className="overflow-auto px-6 pb-6">
          <div className="text-black text-sm mb-4">{t('ACCESSORIES_EMPTY_MESSAGE')}</div>
        </div>

        <div className="cta flex flex-col gap-4">
          <button
            type="button"
            className="btn btn-primary btn-lg flex items-center justify-center w-full"
            disabled={false}
            onClick={onNextHandleClick}
          >
            {t('NEXT')}
          </button>

          <button
            type="button"
            className="btn btn-error btn-lg flex items-center justify-center w-full"
            disabled={false}
            onClick={() => setNextModalVisible(false)}
          >
            {t('CANCEL')}
          </button>
        </div>
      </BottomSheet>

      <div className="cta">
        <div className="flex justify-between items-center gap-2">
          <button
            className="btn btn-warning btn-lg flex gap-2 items-center justify-center w-full"
            disabled={uploadLink.loading || loading}
            onClick={() => (mode == 'LIST' ? props.handleBack() : setMode('LIST'))}
          >
            <Icon name="arrow-right" className="w-6 h-6" />
            {t('BACK')}
          </button>
          <button
            className="btn btn-primary btn-lg flex gap-2 items-center justify-center w-full"
            disabled={uploadLink.loading || loading || mode == 'NEW'}
            onClick={() => {
              if (data.length == 0) setNextModalVisible(true)
              else onNextHandleClick()
            }}
          >
            {t('NEXT')}
            <Icon name="arrow-left" className="w-6 h-6" />
          </button>
        </div>
      </div>
    </React.Fragment>
  )
}

export default VehicleAccessoriesPage
